// extracted by mini-css-extract-plugin
export default {"verification":"VerifyPayment_verification__LOuN6","btn":"VerifyPayment_btn__EXEbW"};